import { getGlyph } from '../glyphs';

const Loader = () => {
	return (
		<div className="loader fill">
			{ getGlyph('loader') }
		</div>
	)
}

export default Loader;


// WEBPACK FOOTER //
// ./components/loader/index.js